import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SelectedInsuranceCard from '../../../components/SelectedInsuranceCard';
import InsuranceSteps from '../../../components/InsuranceSteps';
import BackToPreviousPage from '../../../ui/BackToBtn';
import { WrapperHeader, PageTitle } from '../styles';

import {
  InsuranceParameters,
  Offers,
  SetInsuranceParameters,
} from '../../../types';

const InsuranceOrderHeader: React.FC<{
  parameters: InsuranceParameters;
  setInsuranceParameters: SetInsuranceParameters;
  selectedOffer: Array<Offers>;
}> = ({ parameters, selectedOffer }) => {
  const { t } = useTranslation();  

  return (
    <WrapperHeader>
      <InsuranceSteps activeStep={3} />
      <Box sx={{position: 'relative'}}>
        <BackToPreviousPage url={'/offers'}/>
        <PageTitle>{t('form_insurance')}</PageTitle>
      </Box>
      {selectedOffer && (
        <SelectedInsuranceCard
          parameters={parameters}
          selectedOffer={selectedOffer}
        />
      )}
    </WrapperHeader>
  );
};

export default InsuranceOrderHeader;
